import { render, staticRenderFns } from "./ChangeCourseCampus.vue?vue&type=template&id=af2114d2&scoped=true&"
import script from "./ChangeCourseCampus.vue?vue&type=script&lang=ts&"
export * from "./ChangeCourseCampus.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeCourseCampus.vue?vue&type=style&index=0&id=af2114d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2114d2",
  null
  
)

export default component.exports